<style scoped>
.blur-behind {
  backdrop-filter: blur(10px);
}
</style>

<template>
  <v-container align-center fluid>
    <v-layout align-center justify-space-around column>
      <v-flex>
        <v-row>
          <v-col>
            <v-list
              flat
              nav
              color=rgba(255,255,255,0)
              max-width=768
            >
              <v-list-item :href=permalink>
                <v-list-item-avatar size=50>
                  <v-img :src=thumbnail></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title><strong>{{title}}</strong></v-list-item-title>
                  <v-list-item-subtitle>{{subreddit}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <v-layout>
          <v-col>
            <!-- <v-row justify=space-around>
              <v-col>
                <Adsense
                  data-ad-client="ca-pub-0588060391204034"
                  data-ad-slot="8125422280"
                  :data-full-width-responsive=true
                >
                </Adsense>
              </v-col>
            </v-row> -->

            <v-row justify=space-around>
              <v-col>
                <v-skeleton-loader
                  v-if=loading
                  :loading="loading"
                  transition= "fade-transition"
                  type="list-item-avatar-two-line"
                ></v-skeleton-loader>
                <muxer v-if=audio_available&&!loading&&!api_available></muxer>
                <MergeButton
                  v-if=audio_available&&!loading&&api_available
                  :audio_url=this.audio_api
                  :video_url=this.video_api
                  :image_url=this.thumbnail
                ></MergeButton>
              </v-col>
            </v-row>

            <!-- <v-row justify=space-around>
              <v-col>
                <Adsense
                  data-ad-client="ca-pub-0588060391204034"
                  data-ad-slot="7223746294"
                  :data-full-width-responsive=true
                >
                </Adsense>
              </v-col>
            </v-row> -->

            <v-row>
              <v-col cols="12" md=6>
                <v-skeleton-loader
                  :loading="loading"
                  transition= "fade-transition"
                  type="card"
                  min-width="320px"
                >
                  <v-card
                    :href=video_url
                    :hover=true
                    target = "_blank"
                    max-width="360px"
                    >
                      <v-img
                        height="240px"
                        width="360px"
                        gradient="to top, rgba(100,115,201,.03), rgba(25,32,72,.6)"
                        :lazy-src=thumbnail
                      >
                        <v-layout justify-center class="blur-behind">
                          <v-icon size=240 color=rgba(255,255,255,0.8)>tv</v-icon>
                        </v-layout>
                      </v-img>
                    <v-card-title>Get Only Video</v-card-title>
                    <v-card-subtitle>Right-Click -> Save link as...</v-card-subtitle>
                  </v-card>
                </v-skeleton-loader>
              </v-col>
              <v-col cols="12" md=6>
                <v-skeleton-loader
                  :loading="loading"
                  transition= "fade-transition"
                  class="mx-auto"
                  type="card"
                  min-width="320px"
                >
                  <v-card
                    v-if=audio_available
                    :href=audio_url
                    :hover=true
                    target="_blank"
                    max-width="360px"
                  >
                    <v-img
                      height="240px"
                      width="360px"
                      gradient="to top, rgba(100,115,201,.03), rgba(25,32,72,.6)"
                      :lazy-src=thumbnail
                    >
                      <v-layout justify-center class="blur-behind">
                        <v-icon size=240 color=rgba(255,255,255,0.8)>speaker</v-icon>
                      </v-layout>
                    </v-img>
                    <v-card-title>Get Only Audio</v-card-title>
                    <v-card-subtitle>Right-Click -> Save link as...</v-card-subtitle>
                  </v-card>

                  <v-card
                    v-else
                    flat
                    disabled
                    max-width="360px"
                  >
                    <v-img
                      height="240px"
                      width="360px"
                      gradient="to top, rgba(100,115,201,.03), rgba(25,32,72,.6)"
                    >
                      <v-layout justify-center>
                        <v-icon size=240 color=rgba(0,0,0,0.1)>volume_off</v-icon>
                      </v-layout>
                    </v-img>
                    <v-card-title>No Audio</v-card-title>
                    <v-card-subtitle>This post doesn't have any audio.</v-card-subtitle>
                  </v-card>
                </v-skeleton-loader>
              </v-col>
            </v-row>
          </v-col>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Muxer from './Muxer.vue'
import MergeButton from './MergeButton.vue'

export default {
  created () {
    this.mux()
  },
  methods: {
   mux: function() {
      this.loading = true
      var url = new URL(window.location.pathname, "https://www.reddit.com/r/")

      fetch(url+".json")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          var post_info = myJson[0].data.children[0].data
          this.permalink = "https://www.reddit.com"+post_info.permalink
          this.title = post_info.title
          this.subreddit = post_info.subreddit_name_prefixed
          this.thumbnail = post_info.thumbnail

          var video_info = post_info.secure_media.reddit_video

          // data.preview can be undefined for removed posts
          if ((post_info.preview) && !(post_info.over_18)) {
            this.video_preview_url = (post_info.preview.images[0].source.url)
            // Unescape the HTML encoded url for the preview image
            this.video_preview_url = new DOMParser().parseFromString(this.video_preview_url, "text/html").documentElement.textContent
          }

          this.info = video_info
          this.info.video_url = video_info.fallback_url
          this.video_url = this.info.video_url

          var temp_url = new URL(this.info.video_url)
          temp_url = new URL(this.api_sub_path + temp_url.pathname, this.api_origin)
          this.video_api = temp_url.toString()

          this.audio_available = !video_info.is_gif

          var audio_url = new URL(this.info.video_url)
          var pathArray = audio_url.pathname.split("/")
          var audioPath = ""
          for (var i = 0; i < pathArray.length-1; i++) {
            audioPath += pathArray[i];
            audioPath += "/";
          }
          // TODO: Add back support for this URL scheme.
          // audio_url.pathname = audioPath + "DASH_audio.mp4"
          audio_url.pathname = audioPath + "DASH_AUDIO_128.mp4"
          this.audio_url = audio_url.toString()

          temp_url = new URL(this.api_sub_path + audio_url.pathname, this.api_origin)

          // Check if audio is available, if at all, at new url or old url
          if(this.audio_available) {
            let that = this
            fetch(temp_url)
              .then(function(response) {
                if(response.ok) {
                  that.audio_api = temp_url.toString()
                } else {
                  let old_url = new URL(that.api_sub_path + audioPath + "audio", that.api_origin)
                  fetch(old_url)
                    .then(function(response){
                      if(response.ok) {
                        that.audio_api = old_url.toString()
                        audio_url.pathname = audioPath + "audio"
                        that.audio_url = audio_url.toString()
                      } else {
                        that.audio_available = false
                      }
                    })
                }
              })
          }

          this.loading = false
        }.bind(this));
  }
  },
  data: () => ({
    info : {},
    loading: false,
    api_available: true,
    api_origin: "https://api.reddit.watch/",
    api_sub_path: "proxy",
    audio_available: false,
    video_api: "",
    audio_api: "",
    video_url: "",
    audio_url: "",
    video_preview_url: require('../assets/icon.png'),
    thumbnail: "",
    title: "",
    subreddit: "",
    permalink: "",
  }),
  components: {
    "muxer": Muxer,
    MergeButton
  }
};
</script>
